export type ModalCssOptions = {
  customClassName?: string;
  overrideCss?: boolean;
  header?: boolean;
};

export type ModalCss = {
  modalClassCss: string;
  modalContentCss: string;
  modalBackgroundCss: string;
  modalCloseButtonCss: string;
  modalHeaderCss: string;
};

export const modalCss = ({
  customClassName,
  overrideCss = false,
  header = false,
}: ModalCssOptions = {}): ModalCss => {
  const modalClassCss = [];
  const modalContentCss = [];
  const modalBackgroundCss = [];
  const modalButtonCss = [];
  const modalHeaderCss = [];

  if (!overrideCss) {
    modalClassCss.push('modal');
    modalContentCss.push('modal__content');
    modalBackgroundCss.push('modal__backdrop');
    modalButtonCss.push('modal__close-button');
    modalHeaderCss.push('modal__header');
  }

  if (customClassName) {
    modalClassCss.push(`${customClassName}`);
    modalContentCss.push(`${customClassName}__content`);
    modalBackgroundCss.push(`${customClassName}__backdrop`);
    modalButtonCss.push(`${customClassName}__close-button`);
    modalHeaderCss.push(`${customClassName}__header`);
  }

  if (header) {
    if (!overrideCss) {
      modalContentCss.push('modal__content--header-active');
    }

    if (customClassName) {
      modalContentCss.push(`${customClassName}__content--header-active`);
    }
  }

  return {
    modalClassCss: modalClassCss.join(' '),
    modalContentCss: modalContentCss.join(' '),
    modalBackgroundCss: modalBackgroundCss.join(' '),
    modalCloseButtonCss: modalButtonCss.join(' '),
    modalHeaderCss: modalHeaderCss.join(' '),
  };
};
